import { useEffect, useState } from 'react'
import Tabs from '../../ui-components/Tabs'
import { EliteScoresResponseType, EliteScoresTypes } from '../../../types/mutual-fund-detail.types'
import EliteScoreLeaderboardSection from './EliteScoreLeaderboardSection'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import EliteScoreTrendSection from './EliteScoreTrendSection'
import { eliteScoresEnumKeyMapping } from '../../../constants'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { toPascalCaseWithSpaces } from '../../../utils/utils'

enum EliteBodyTabs {
  SCORE_TREND = 'Score Trend',
  LEADERBOARD = 'Leaderboard'
}

export default function EliteScoreBody({
  eliteScoresType,
  eliteCardData
}: {
  eliteScoresType: `${EliteScoresTypes}`
  eliteCardData: EliteScoresResponseType | undefined
}) {
  const [selectedTabId, setSelectedTabId] = useState<`${EliteBodyTabs}`>(EliteBodyTabs.SCORE_TREND)
  const { data: metadata } = useMetaDataContext()
  const accessorKey = eliteScoresEnumKeyMapping?.[eliteScoresType]

  return (
    <div className='flex flex-col w-full pt-[11px]'>
      <div className='pb-5 w-full'>
        <div className='h-11'>
          <Tabs
            selectedTabId={selectedTabId}
            tabsData={[
              { id: EliteBodyTabs.SCORE_TREND, label: EliteBodyTabs.SCORE_TREND },
              { id: EliteBodyTabs.LEADERBOARD, label: EliteBodyTabs.LEADERBOARD }
            ]}
            onTabClick={(id) => setSelectedTabId(() => id as `${EliteBodyTabs}`)}
            isFullWidth
            tabsClassName='h-[40px]'
          />
        </div>
      </div>
      {{
        [EliteBodyTabs.SCORE_TREND]: (
          <EliteScoreTrendSection
            eliteScoreData={eliteCardData?.[accessorKey]}
            eliteScoresType={eliteScoresType}
            categoryCount={eliteCardData?.categoryCount ?? 0}
          />
        ),
        [EliteBodyTabs.LEADERBOARD]: (
          <EliteScoreLeaderboardSection
            eliteScoresType={eliteScoresType}
            fundCategory={metadata?.fundDetails?.category ?? ''}
          />
        )
      }[selectedTabId] || <div className='h-[400px] w-full' />}
    </div>
  )
}
